import {create} from "zustand";
import { CalendarEventType } from '@/features/calendar/types/calendar-dto';

type NewsAndOffersFilter = {
    filter: {
        startDate?: Date | null;
        endDate?: Date | null;
        types?: CalendarEventType[];
    },
    setFilter: ( filter: NewsAndOffersFilter['filter'] ) => void;
    resetFilter: () => void;
};

export const useCalendarFilter = create<NewsAndOffersFilter>((set) => ({
    filter: {
        startDate: undefined, 
        endDate: undefined,
        types: undefined,
    },
    setFilter: (filter) => {
        set({
            filter: {
                ...filter
            },
        });
    },
    resetFilter: () => {
        set({ 
            filter: {
                startDate: null, 
                endDate: null,
                types: [],
            } 
        });
    },
}));